import { queryClient } from '../../query';
import { callGetApi, callPutApi, callPostApi } from '../apiCallerProxy';
import { accountsApiFactory } from './accountsApiFactory';

export { API_CACHE_KEY } from './keys';
export * from './hooks';
export default accountsApiFactory({ callGetApi, callPutApi, callPostApi, queryClient });
